export var line3 = {
  originData: [{
    date: '3月1日',
    'x': 121.15221380436526,
    'z': 121.15221380436526,
    'y': 45.14612970770014
  },
  {
    'date': '3月2日',
    'x': 157.34111997704167,
    'z': 121.15221380436526,
    'y': 97.0854323316857
  },
  {
    'date': '3月3日',
    'x': 142.8339415142327,
    'z': 142.8339415142327,
    'y': 20.9288118011757
  },
  {
    'date': '3月4日',
    'x': 194.22532846084,
    'z': 124.22532846084,
    'y': 23.91613434773916
  },
  {
    'date': '3月5日',
    'x': 152.518054338884,
    'z': 162.518054338884,
    'y': 23.8163589745027
  },
  {
    'date': '3月6日',
    'x': 168.5471554311728,
    'z': 162.518054338884,
    'y': 30.8107488255147
  },
  {
    'date': '3月7日',
    'x': 160.1353666113585,
    'z': 162.518054338884,
    'y': 24.0452483170851
  },
  {
    'date': '3月8日',
    'x': 207.16121681819442,
    'z': 162.518054338884,
    'y': 12.64405934535216
  },
  {
    'date': '3月9日',
    'x': 164.99182276394873,
    'z': 182.518054338884,
    'y': 17.94002011838893
  },
  {
    'date': '3月10日',
    'x': 200.72166709079318,
    'z': 262.518054338884,
    'y': 29.19173121863057
  },
  {
    'date': '3月11日',
    'x': 387.60085955230215,
    'z': 362.518054338884,
    'y': 31.4499830216107
  }
  ]
}
